import { z } from "zod";

/**
 * SubScenario Form Data
 *
 * BE expects: { scenario_id: string, start_step_id?: string | null }
 * FE uses: { scenario: string } which maps to BE scenario_id
 *
 * See settingsMappers.ts for the mapping.
 */
export const subScenarioFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    scenario: z.string(), // Maps to BE scenario_id
});

export type SubScenarioFormData = z.infer<typeof subScenarioFormSchema>;
